document.addEventListener("DOMContentLoaded", () => {
  const stickyButton = document.getElementById("sticky_add_to_cart");

  const onWindowScroll = () => {
    const addToCartButtonsTop =
      document.getElementById("add-to-cart-buttons").getBoundingClientRect()
        .top || 10;

    if (addToCartButtonsTop >= 0) {
      stickyButton.className = "sticky_add_to_cart";
    } else {
      const collabBlock = document.getElementById("dovetale-container");
      stickyButton.className = "sticky_add_to_cart is-visible";

      collabBlock.className = "collab-block__hidded";
    }
  };
  window.addEventListener("scroll", onWindowScroll);
});
